import flowRightFP from 'lodash/fp/flowRight';

const parsePassengersCount = (count, defaultCount) => {
  const parsedCount = Number.parseInt(count, 10);

  return Number.isInteger(parsedCount) ? parsedCount : defaultCount;
};

export const pickPassengersValues = ({ adults, children, infants, babies, totalChildren } = {}) => {
  const parsed = {
    adults: parsePassengersCount(adults, 1),
    children: parsePassengersCount(children, 0),
    infants: parsePassengersCount(infants, 0),
    babies: parsePassengersCount(babies, 0),
  };
  const totalCount = parsed.adults + parsed.children + parsed.infants + parsed.babies;

  return {
    ...parsed,
    totalCount,
    totalChildren: totalChildren || [],
  };
};

export const getPassengers = (state) => state.railways.passengers;

export const getPassengersValues = flowRightFP(pickPassengersValues, getPassengers);

export const getLocation = (state) => state.railways.location;
